import React, { FC } from "react";

// import { Icons } from "../../../../../data/Assets";

import ResultLayout from "../../../../layouts/Result";
import ResultContainer from "../../../../reusables/results/ResultContainer";
import ScanScoreCard from "./ScanScoreCard";

// import Drawer from "../Drawer";
import { ICommonScanCriteria } from "../../../../../interfaces/scan_criterias";
import { ICommonCriteriaPoint } from "../../../../../interfaces/criteria_points";
import { IResumeScanner } from "../../../../../interfaces/services";

interface IScanResultsProps {
    studentId: number;
    resumeTitle: string;
    resumeScanDetails: IResumeScanner;
}

const ScanResults: FC<IScanResultsProps> = (props) => {
    const { studentId, resumeTitle, resumeScanDetails } = props;
    // const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

    const commonScanCriterias = resumeScanDetails.scan_criteria_results.map(
        (scanCriteria) => {
            const commonScanCriteria: ICommonScanCriteria = {
                id: scanCriteria.id,
                title: scanCriteria.title,
                description: scanCriteria.description,
                type: scanCriteria.type,
                level: scanCriteria.level,
                criteria_points: scanCriteria.criteria_points.map((criteriaPoint) => {
                    const commonCriteriaPoint: ICommonCriteriaPoint = {
                        id: criteriaPoint.id,
                        scan_criteria_id: criteriaPoint.scan_criteria_id,
                        title: criteriaPoint.title,
                        description: criteriaPoint.description,
                        result: {
                            level: criteriaPoint.scan_result.level,
                            review: criteriaPoint.scan_result.ai_review,
                            score: criteriaPoint.scan_result.score,
                        },
                    };

                    return commonCriteriaPoint;
                }),
            };

            return commonScanCriteria;
        }
    );

    return (
        <ResultLayout
            title={resumeTitle}
            onTitleClick={() => { }}
        // onTitleClick={() => setIsDrawerOpen(true)}
        >

            <ScanScoreCard
                studentId={studentId}
                mediaId={resumeScanDetails.media_id}
                score={resumeScanDetails.overall_score}
            />

            <ResultContainer scanCriterias={commonScanCriterias} />

            {/* <Drawer
                isOpen={isDrawerOpen}
                title="Richard Jaff_Resume"
                onClose={() => setIsDrawerOpen(false)}
                closeIcon={Icons.Cross}
            >
                <ImageAsset src={MockImg} alt="Resume preview" className="immersion__drawer_preview_img" />
            </Drawer> */}
        </ResultLayout>
    );
};

export default ScanResults;
